// extracted by mini-css-extract-plugin
module.exports = {"field":"switch-field_field__1ZcWW","title":"switch-field_title__2-pXj"};